import { Button, Divider, Grid } from '@material-ui/core';
import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import ClientiRowsTable from './ClientiRowsTable';
import FacturiRowsTable from './FacturiRowsTable';


export default class DateDespreClientRows extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
    }
    render() {
        return (

            <Grid container>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>



                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                            <Grid container>
                                <Grid style={{ textAlign: 'left' }} item xs={8} sm={8} md={8} lg={8} xl={8}>
                                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} > {this.props.client.nume}</h5>

                                </Grid>

                                <Grid style={{ textAlign: 'left' }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} > {this.dictionary.financiar.soldTotal}: {this.props.client.sold_total} Lei</h5>
                                </Grid>
                            </Grid>



                            <Divider style={{ marginBottom: 20 }} className='pm-divider' />
                        </Grid>

                        <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                            {this.props.facturiRows.length > 0 &&

                                <FacturiRowsTable
                                    facturi={this.props.facturiRows}
                                    editFactura={this.props.editFactura}
                                    dictionary={this.dictionary}
                                    deleteFactura={this.props.deleteFactura}
                                />

                            }


                            {this.props.facturiRows.length === 0 &&

                                <span style={{ fontSize: 16 }}>{this.dictionary.financiar.nuAvemFacturi} </span>
                            }






                            {this.props.facturiRows.length === 0 &&
                                <Divider style={{ marginTop: 20 }} className='pm-divider' />
                            }


                        </Grid>




                        <Grid style={{ textAlign: 'left', paddingTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                            <Button
                                style={{ marginRight: 20 }}

                                className={'add-button-blue'} onClick={() => { this.props.addFacturaNoua() }}  >

                                <i style={{
                                    fontSize: 14,
                                    marginRight: 10
                                }} className='material-icons'>add</i>  {this.dictionary.financiar.adaugaFacturaNoua}
                            </Button>

                            <Button
                                style={{ marginRight: 20 }}

                                className={'inapoi-button-blue'} onClick={this.props.inapoi}  >

                                <i style={{
                                    fontSize: 14,
                                    marginRight: 10
                                }} className='material-icons'>keyboard_arrow_left</i>  {this.dictionary.financiar.inapoi}
                            </Button>
                        </Grid>

                    </Grid>




                </Grid>



            </Grid>

        );
    }
}